import { getQueryString } from "utils/getQueryString";
import axios from "../axios";

const getAll = (params) =>
  axios.get(`/subscriptions?${getQueryString(params)}`);

const create = (data) => axios.post("/subscriptions", data);

const getOne = (subscriptionId) =>
  axios.get(`/subscriptions/${subscriptionId}`);

const update = (commentId, data) =>
  axios.put(`/subscriptions/${commentId}`, data);

const remove = (commentId) => axios.delete(`/subscriptions/${commentId}`);

const addFeature = (subscriptionId, data) =>
  axios.post(`/subscriptions/${subscriptionId}/features`, data);

const updateFeature = (subscriptionId, featureId, data) =>
  axios.put(`/subscriptions/${subscriptionId}/features/${featureId}`, data);

const deleteFeature = (subscriptionId, featureId) =>
  axios.delete(`/subscriptions/${subscriptionId}/features/${featureId}`);

const addCurrency = (subscriptionId, data) =>
  axios.post(`/subscriptions/${subscriptionId}/currencies`, data);

const updateCurrency = (subscriptionId, currencyId, data) =>
  axios.put(`/subscriptions/${subscriptionId}/currencies/${currencyId}`, data);

const deleteCurrency = (subscriptionId, currencyId) =>
  axios.delete(`/subscriptions/${subscriptionId}/currencies/${currencyId}`);

const subscriptionService = {
  getAll,
  create,
  update,
  remove,
  addFeature,
  updateFeature,
  deleteFeature,
  addCurrency,
  updateCurrency,
  deleteCurrency,
  getOne,
};

export default subscriptionService;
